import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 迁移日志列表
export const setMigrationLogs: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 迁移日志详情
export const setMigrationDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};
